import { useEntriesV2 } from "@/Hooks"
import { useAuth0 } from "@auth0/auth0-react"
import { useEffect, useImperativeHandle, useState } from "react"
import { isResellerAdmin, isSuperAdminOrAdmin } from "../../../../Utils/util"
import { disableDirectTunnelMessage } from "../store/states"


export const useDirectTunnelToggleButton = (ref, dimmerDirectTunnel, directTunnelStatus, refreshServiceStatus, orgId, handleDimmerDirectTunnel) => {
	const { data: directTunnelStatusData } = directTunnelStatus
	const { user } = useAuth0()
	const [toggleDirectTunnelState, { postData: toggleDirectTunnel, reset }] = useEntriesV2("/api/v2/device/configure/directTunnel", () => {
		if (dimmerDirectTunnel.isDimmed) return
		refreshServiceStatus()
	})
	const [isDisabledToggleButton, setIsDisabledToggleButton] = useState(false)

	const handleToggleButton = (checked) => {
		if (checked) handleDimmerDirectTunnel(disableDirectTunnelMessage.POST_ENABLE_DIRECT_TUNNEL)
		toggleDirectTunnel({ enableDirectTunnel: checked, serialnumber: directTunnelStatusData?.serialnumber, featureBitmap: 1 })
	}

	useEffect(() => {
		if (isSuperAdminOrAdmin(user)) {
			setIsDisabledToggleButton(false)
		} else if (isResellerAdmin(user) && user.orgId === orgId) {
			setIsDisabledToggleButton(false)
		} else {
			setIsDisabledToggleButton(true)
		}
	}, [user])

	useImperativeHandle(ref, () => ({
		resetPost: reset
	}))

	return { isDisabledToggleButton, toggleDirectTunnelState, handleToggleButton }
}
